import Vue from 'vue'

Vue.prototype.$eventBus = new Vue()

export const EVENT_LOGOUT_AFTER = 'logout.after'
export const EVENT_LOGIN_AFTER = 'login.after'
export const EVENT_GAME_RESULT_ADDED = 'gameinstance.result.added' // {gameuid: x}
export const EVENT_GAME_RESULT_AVAILABLE = 'gameinstance.result.available' // {gameuid: x, matchUid: y, result: {confirmedAt: ..., goals: ..., opponent_goals: ...}}
export const EVENT_GAMEINSTANCE_UPDATED = 'gameinstance.updated'
export const EVENT_REFRESH_DATA = 'refreshData'
export const EVENT_PUSHER_AVAILABLE = 'pusher.available'
export const EVENT_PUSHER_EVENT_RECEIVED = 'pusher.event.received'
export const EVENT_GA_AVAILABLE = 'googleAnalytics.available'
export const EVENT_REALTIME_ECHO_REGISTERED = 'pusher.echo.registered'
export const EVENT_ACCESS_TOKEN_UPDATED = 'accessTokenUpdated'
export const EVENT_SCHEDULES_AVAILABLE = 'gameinstance.schedules.available'

export const EVENT_SHOW_PREMIUM_OPTIONS = 'show.premiumOptions'
export const EVENT_SHOW_COINS_DIALOG = 'show.coinsDialog'
export const EVENT_SHOW_ONLINE_IDS_DIALOG = 'show.onlineIdsDialog'
export const EVENT_SHOW_ADDITIONAL_USER_DATA_DIALOG = 'show.additionUserDataDialog'
export const EVENT_NAVIGATE_TO = 'navigate.to'

export const EVENT_EXT_NATIVE_APP_READY = 'ext.nativeAppReady'
export const EVENT_EXT_NATIVE_APP_NOTIFICATION_INFO = 'ext.nativeAppNotificationInfo'
export const EVENT_EXT_NATIVE_APP_PUSH_NOTIFICATION_INFO = 'ext.nativeAppPushNotificationInfo'

export const EVENT_BANK_ACCOUNTS_CHANGED = 'bankAccount.changed'
export const EVENT_STORE_ENV_UPDATED = 'store.envUpdated'

export default Vue.prototype.$eventBus
